const TIME_OF_DAY = /^([01]\d|2[0-3]):([0-5]\d)$/;
const ISO_TIME_OF_DAY = /T(\d{2}:\d{2})/;

export const SendingTime = {
  isValid(value: string): boolean {
    return TIME_OF_DAY.test(value);
  },
  toMinutes(value: string): number {
    const [hours, minutes] = value.split(':').map(Number);
    return hours * 60 + minutes;
  },
  isBefore(start: string, end: string): boolean {
    return SendingTime.toMinutes(start) < SendingTime.toMinutes(end);
  },
  fromIso(iso?: string): string {
    return ISO_TIME_OF_DAY.exec(iso ?? '')?.[1] ?? '';
  },
};
